/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Error_Deleting_Translation_FileInputs */



/**
* | output |
* | --- |
* | "Error deleting translation file: {error}" |
*
* @param {Error_Deleting_Translation_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_deleting_translation_file = /** @type {((inputs: Error_Deleting_Translation_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Deleting_Translation_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de la suppression du fichier de traduction : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Löschen der Übersetzungsdatei: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante l'eliminazione del file di traduzione: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при удалении файла перевода: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al eliminar el archivo de traducción: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除翻译文件时出错：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`翻訳ファイルの削除中にエラーが発生しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अनुवाद फ़ाइल को हटाने में त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao excluir o arquivo de tradução: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error deleting translation file: ${i?.error}`)
});